import React from 'react';
import { useErrorContext } from '../../utils/Error/hooks/useErrorContext';
import { Banner } from '../Banner/Banner';

/**
 * Use together with `ErrorProvider` & `displayMode=banner` to catch errors in context.
 */
export const ErrorBanner = () => {
  const { errorDisplayMessage, clearError } = useErrorContext();

  return errorDisplayMessage ? (
    <Banner
      priority="error"
      heading={errorDisplayMessage.title}
      paragraph={errorDisplayMessage.description}
      isCloseable={true}
      onClose={clearError}
    />
  ) : null;
};
